import { Button } from '@nextui-org/react';
import MarketRetail from 'common/src/sections/home/MarketRetail';
import useDataStore from 'common/src/stores/useDataStore';
import useUserStore from 'common/src/stores/useUserStore';
import { useRetailPreferences } from 'common/src/hooks/useRetailPreferences';
import { useTranslation } from 'common/src/hooks/useTranslation';
import RetailSkuPreferences from './RetailSkuPreferences';
import { LoadingState } from '../../components/ui';

function RetailWithPreferences({
  speciesId,
  exporterId,
}: {
  speciesId: number;
  exporterId: number;
}) {
  const { t } = useTranslation('market');
  const { preferences, status, saveState, update, reload } =
    useRetailPreferences(exporterId, speciesId);

  // Esperamos las preferencias antes de dibujar: si no, el gráfico mostraría
  // todos los SKUs de la especie y recién después se acotaría a los seguidos.
  if (status === 'loading') {
    return <LoadingState label={t('Cargando tu configuración de retail…')} />;
  }

  if (status === 'error') {
    return (
      <div className='flex h-screen flex-col items-center justify-center gap-3'>
        <p className='text-danger'>
          {t('No pudimos cargar la configuración de retail.')}
        </p>
        <Button size='sm' onPress={reload}>
          {t('Reintentar')}
        </Button>
      </div>
    );
  }

  return (
    <MarketRetail
      properties={preferences.properties}
      propertyAssignments={preferences.assignments}
      targetSkuIds={
        preferences.followed.length ? preferences.followed : undefined
      }
      actionsSlot={
        <RetailSkuPreferences
          speciesId={speciesId}
          preferences={preferences}
          onChange={update}
          saveState={saveState}
        />
      }
    />
  );
}

export default function RetailMarketPage() {
  const { selectedSpecies } = useDataStore();
  const { exporter, userProfile } = useUserStore();
  const exporterId =
    exporter?.id ?? userProfile?.exporter_id ?? userProfile?.exporter?.id;

  // Sin exportadora (p. ej. superadmin sin una asignada) no hay dónde guardar
  // la configuración, así que mostramos el retail completo sin seguimiento.
  return selectedSpecies && exporterId ? (
    <RetailWithPreferences
      key={`${exporterId}:${selectedSpecies.id}`}
      speciesId={selectedSpecies.id}
      exporterId={exporterId}
    />
  ) : (
    <MarketRetail />
  );
}
